import { ILoginResponse } from '@aqx-core/common/api/auth';
import { IMetatraderLoginMobileParams, IMetatraderLoginWebParams } from '@aqx-core/common/api/metatrader-login';
import { request } from '@aqx-core/common/request';

export default {
  loginWebMT4Demo: (params: IMetatraderLoginWebParams) =>
    request.post<ILoginResponse>('/api/auth/v2/metatrader4/demo/login', params),
  loginMobileMT4Demo: (params: IMetatraderLoginMobileParams) =>
    request.post<ILoginResponse>('/api/auth/v2/metatrader4/demo/mobile/login', params),
  loginWebMT4Live: (params: IMetatraderLoginWebParams) =>
    request.post<ILoginResponse>('/api/auth/v2/metatrader4/live/login', params),
  loginMobileMT4Live: (params: IMetatraderLoginMobileParams) =>
    request.post<ILoginResponse>('/api/auth/v2/metatrader4/live/mobile/login', params),
  loginWebMT5Demo: (params: IMetatraderLoginWebParams) =>
    request.post<ILoginResponse>('/api/auth/v2/metatrader5/demo/login', params),
  loginMobileMT5Demo: (params: IMetatraderLoginMobileParams) =>
    request.post<ILoginResponse>('/api/auth/v2/metatrader5/demo/mobile/login', params),
  loginWebMT5Live: (params: IMetatraderLoginWebParams) =>
    request.post<ILoginResponse>('/api/auth/v2/metatrader5/live/login', params),
  loginMobileMT5Live: (params: IMetatraderLoginMobileParams) =>
    request.post<ILoginResponse>('/api/auth/v2/metatrader5/live/mobile/login', params)
};
